import { Divider } from 'src/design/atoms/Divider';
import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import { Switch } from 'src/design/atoms/Switch';
import React from 'react';
import { Modal } from 'src/design/molecules/Modal';

export interface DisplayOptions {
  hideCostCodes: boolean;
  alwaysShowCostCodesForCTC: boolean;
}

interface DisplayOptionsModalProps {
  opened: boolean;
  onClose: () => void;
  options: DisplayOptions;
  onOptionsChange: (options: DisplayOptions) => void;
}

export const DisplayOptionsModal: React.FC<DisplayOptionsModalProps> = ({
  opened,
  onClose,
  options,
  onOptionsChange,
}) => {
  const handleOptionChange = (key: keyof DisplayOptions, value: boolean) => {
    onOptionsChange({
      ...options,
      [key]: value,
    });
  };

  return (
    <Modal title="Display Options" opened={opened} onClose={onClose} size="lg">
      <Stack gap="lg">
        <Text>
          These settings only change how the work breakdown looks on this
          screen.
        </Text>
        <Text>
          Your display choices are saved in your browser. You can reset them by
          clearing your browser data or changing the options below.
        </Text>
        <Divider />
        <Switch
          label="Hide Cost Codes"
          description="Only show account names, hide the cost code numbers"
          checked={options.hideCostCodes}
          onChange={(event) =>
            handleOptionChange('hideCostCodes', event.currentTarget.checked)
          }
        />
        <Switch
          label="Always Show Cost Codes for CTC Accounts"
          description="Always display cost codes for items linked to CTC"
          checked={options.alwaysShowCostCodesForCTC}
          onChange={(event) =>
            handleOptionChange(
              'alwaysShowCostCodesForCTC',
              event.currentTarget.checked,
            )
          }
        />
      </Stack>
    </Modal>
  );
};
